import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { mergeRouteParams } from 'app/helpers';
import { PosRoleEnum } from 'app/interfaces';
import { NotificationsService, PointOfSaleService } from 'app/services';

export const posCashierRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const pointOfSaleService = inject(PointOfSaleService);
    const notificationsService = inject(NotificationsService);

    const handleUnauthorized = (): boolean => {
        notificationsService.translateError('pos.unauthorized');
        router.navigate(['/']);
        return false;
    };

    const params = mergeRouteParams(route);
    if (params.posId) {
        return pointOfSaleService.getPointOfSaleRole(params.posId).pipe(
            map((role) => {
                if (role === PosRoleEnum.Admin || role === PosRoleEnum.Cashier) {
                    return true;
                }
                return handleUnauthorized();
            }),
        );
    }
    return handleUnauthorized();
};
